import { render, staticRenderFns } from "./WeightDiscrepancyManager.vue?vue&type=template&id=5328d69c&scoped=true&"
import script from "./WeightDiscrepancyManager.vue?vue&type=script&lang=js&"
export * from "./WeightDiscrepancyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328d69c",
  null
  
)

export default component.exports